import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'


@Component({
    selector: 'app-asda-message-popup',
    templateUrl: './asda-message-popup.component.html',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
    ],
})
export class AsdaMessagePopupComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string; title: string }) {
    }

}
